import React, { Component } from "react";
import {
  Breadcrumb,
  Container,
  Header,
  Grid,
  Menu,
  Segment,
  Message,
} from "semantic-ui-react";
import { Link } from "react-router-dom";
import { translate } from "react-i18next";
import AuthManagement from "feathers-authentication-management/lib/client";
import NewPasswordForm from "../forms/NewPasswordForm";
import EmailChangeForm from "../forms/EmailChangeForm";
import { connect } from "react-redux";
import { push } from "react-router-redux";

class ProfileView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      oldPassword: "",
      newPassword: "",
      newEmail: "",
      emailDuplicate: "",
      message: null,
      passwordDuplicate: "",
      error: null,
    };

    this.FeathersService = this.props.services.feathers;
    this.UserService = this.FeathersService.service("users");
    this.AuthManager = AuthManagement(this.FeathersService);
  }

  static mapStateToProps(state) {
    return {
      routing: state.routing,
      authentication: state.authentication.toJS(),
    };
  }

  static mapDispatchToProps(dispatch) {
    return {
      navigate: (path) => dispatch(push(path)),
    };
  }

  changePassword = (oldPassword, newPassword, email) => {
    this.setState({
      loading: true,
      error: null,
      message: null,
    });
    this.AuthManager.passwordChange(oldPassword, newPassword, { email })
      .then((result) => {
        console.log("changePassword", result);
        this.setState({
          loading: false,
          error: null,
          message: "SuccessChangePassword",
          newPassword: "",
          passwordDuplicate: "",
        });
      })
      .catch((error) => {
        console.log("changePassword", "error", error);
        this.setState({ error, loading: false, message: null });
      });
  };

  changeEmail = (password, newEmail, email) => {
    this.AuthManager.identityChange(password, { email: newEmail }, { email })
      .then((result) => {
        console.log("changeEmail", result);
        this.setState({
          loading: false,
          error: null,
          message: "SuccessChangeEmail",
          newEmail: "",
          emailDuplicate: "",
        });
      })
      .catch((error) => {
        console.log("changePassword", "error", error);
        this.setState({ error, loading: false, message: null });
      });
  };

  createInputHandler(name) {
    return (e, input) => {
      this.setState({
        [name]: e.target.value,
      });
    };
  }

  render() {
    const { t } = this.props;

    let {
      loading,
      error,
      message,
      oldPassword,
      newPassword,
      newEmail,
      emailDuplicate,
      passwordDuplicate,
    } = this.state;
    const authentication = this.props.authentication || {};
    const user = authentication.user;
    if (!user || !user.email) {
      return (
        <Container>
          <Message warning header="Sesion" content="Debe iniciar sesion para ver su perfil." />
        </Container>
      );
    }
    let newPasswordProps = {
      oldPassword,
      newPassword,
      passwordDuplicate,
      loading,
      error,
    };
    let emailChangeProps = {
      newEmail,
      oldPassword,
      emailDuplicate,
      loading,
      error,
    };
    const changePassword = () => {
      this.changePassword(oldPassword, newPassword, user.email);
    };

    const changeEmail = () => {
      this.changeEmail(oldPassword, emailChangeProps, user.email);
    };

    return (
      <Container>
        <Menu
          inverted
          style={{ backgroundColor: "#136444", borderRadius: 0, margin: 0 }}
        >
          <Menu.Item as={Link} name="inicio" active={true} to="/dashboard" />
          <Menu.Item
            active={false}
            as={Link}
            name="mis reservas"
            to="/reservations"
          />
          <Menu.Item active={false} as={Link} name="mi saldo" to="/balance" />
        </Menu>

        <Segment vertical secondary style={{ padding: 4 }}>
          <Breadcrumb>
            <Breadcrumb.Section as={Link} link to={"/dashboard"}>
              Inicio
            </Breadcrumb.Section>
            <Breadcrumb.Divider icon="right angle" />
            <Breadcrumb.Section active>Perfil</Breadcrumb.Section>
          </Breadcrumb>
        </Segment>

        <Segment vertical>
          <Header as="h3">
            <Header.Content>
              PERFIL
              <Header.Subheader>
                Configuracion de perfil de usuario
              </Header.Subheader>
            </Header.Content>
          </Header>
        </Segment>

        <Segment vertical>
          <Grid columns={3} stackable>
            <Grid.Column></Grid.Column>
            <Grid.Row>
              <Grid.Column>
                {message !== "SuccessChangePassword" ? null : (
                  <Message
                    positive
                    header={t("newPassword.success.header")}
                    content={t("newPassword.success.content")}
                  />
                )}
                <Header>{t("newPassword.form.title")}</Header>
                <NewPasswordForm
                  {...newPasswordProps}
                  createInputHandler={this.createInputHandler.bind(this)}
                  onSubmit={changePassword}
                />
              </Grid.Column>
              <Grid.Column>
                {message !== "SuccessChangeEmail" ? null : (
                  <Message
                    positive
                    header={t("emailChange.success.header")}
                    content={t("emailChange.success.content")}
                  />
                )}
                <Header>{t("emailChange.form.title")}</Header>
                <EmailChangeForm
                  {...emailChangeProps}
                  createInputHandler={this.createInputHandler.bind(this)}
                  onSubmit={changeEmail}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Segment>
      </Container>
    );
  }
}

const i18nEnhancement = translate("translations")(ProfileView);

export default connect(
  ProfileView.mapStateToProps,
  ProfileView.mapDispatchToProps
)(i18nEnhancement);



// WEBPACK FOOTER //
// ./src/components/views/ProfileView.jsx